import { h } from 'preact'

import { TITLES } from '../../../config'
import BackgroundTitle from '../../atom/BackgroundTitle'
import { GenerateImageArticleCollection } from '../../atom/ImageArticle'
import { SiteFooterEntry } from '../../organism/SiteFooter'
import VerticalList, { VerticalListEntry } from '../../molecule/VerticalList'

import styles from './index.module.scss'

export const ArticleFooter = ({ related = [] }) => {
  if (!related.length) {
    return null
  }

  return (
    <SiteFooterEntry className={styles['p-article__footer']}>
      <BackgroundTitle small light>
        {TITLES.RELATED}
      </BackgroundTitle>

      <VerticalList gridMobile>
        {GenerateImageArticleCollection({
          smallTitle: true,
          strokedTitle: true,
          small: true,
          picture: {
            lazy: true,
            maxSize: 768,
            defaultSize: 240,
            crop: {
              width: 4,
              height: 3,
            },
            sizes: '(min-width: 1920px) 350px, (min-width: 1200px) 20vw, (min-width: 720px) 30vw, 50vw',
          },
          entries: related,
          Wrapper: VerticalListEntry,
        })}
      </VerticalList>
    </SiteFooterEntry>
  )
}
